import { profile } from "../data/mock";

const About = () => {
  return (
    <section id="about" className="py-24 md:py-36 bg-[#EEE8DB]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <div className="col-span-12 md:col-span-4 reveal">
            <div className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-4">(01) About</div>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.02] tracking-tight">
              Behind
              <br />
              <span className="italic-display">the lens.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 md:pl-10 md:border-l border-[#1A1A1A]/15 reveal">
            <p className="font-display text-2xl md:text-3xl leading-snug text-[#1A1A1A]">
              {profile.longBio}
            </p>
            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { k: "Based", v: profile.location },
                { k: "Working Since", v: "2019" },
                { k: "Format", v: "Stills + Motion" },
                { k: "Service Area", v: "Austin · San Marcos · San Antonio" },
              ].map((i) => (
                <div key={i.k}>
                  <div className="text-[11px] tracking-[0.2em] uppercase text-[#1A1A1A]/55 mb-2">
                    {i.k}
                  </div>
                  <div className="font-display text-lg">{i.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
